import {useEffect, useMemo, useState} from 'react';
import {
  RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES,
  RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE
} from 'constants/pdpRelatedProducts';
import isAlgoliaRecommendations from 'utils/isAlgoliaRecommendations';

export default function useRelatedProductsState({
  breakpoint,
  isRecommendationsProductsFetched,
  isRecommendationsProductsRefetching,
  isRelatedProductsFetched,
  isRelatedProductsRefetching,
  tabs = []
}) {
  const [relatedProductsActiveTab, setRelatedProductsActiveTab] = useState(
    RELATED_PRODUCTS_TAB_KEY_YOU_MAY_ALSO_LIKE
  );

  const shouldTabbedViewRender =
    breakpoint !== 'xs' && breakpoint !== 'sm' && isAlgoliaRecommendations();

  const tabbedViewIsLoading = useMemo(() => {
    if (
      relatedProductsActiveTab === RELATED_PRODUCTS_TAB_KEY_MORE_FITS_AND_SIZES
    ) {
      return !isRelatedProductsFetched || isRelatedProductsRefetching;
    }

    return (
      !isRecommendationsProductsFetched || isRecommendationsProductsRefetching
    );
  }, [
    relatedProductsActiveTab,
    isRecommendationsProductsFetched,
    isRecommendationsProductsRefetching,
    isRelatedProductsFetched,
    isRelatedProductsRefetching
  ]);

  const hasAnyData = useMemo(() => {
    return tabs.length > 0;
  }, [tabs.length]);

  useEffect(() => {
    if (tabs.length > 0) {
      const activeTabExists = tabs.some(
        (tab) => tab.value === relatedProductsActiveTab
      );
      if (!activeTabExists) {
        setRelatedProductsActiveTab(tabs[0].value);
      }
    }
  }, [tabs, relatedProductsActiveTab]);

  return {
    hasAnyData,
    relatedProductsActiveTab,
    setRelatedProductsActiveTab,
    shouldTabbedViewRender,
    tabbedViewIsLoading
  };
}
